import { render, staticRenderFns } from "./botonWhatsApp.vue?vue&type=template&id=bf43d256&scoped=true&"
import script from "./botonWhatsApp.vue?vue&type=script&lang=js&"
export * from "./botonWhatsApp.vue?vue&type=script&lang=js&"
import style0 from "./botonWhatsApp.vue?vue&type=style&index=0&id=bf43d256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf43d256",
  null
  
)

export default component.exports